export default __webpack_public_path__ + "static/media/1.af9472f1.png";